import { withTranslation } from 'react-i18next'
import { Faixa } from './style'
function DesmonstrationTag({ t }) {
  return <Faixa>{t('admin.item.demonstration')}</Faixa>
}
export default withTranslation()(DesmonstrationTag)
